// ================================================================
// CALENDARIO.JS - Calendário de Atividades e Prescrições
// Sprint 3 - Visualização mensal integrada
// ================================================================

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.operacional = window.FazendaRP.Pages.operacional || {};

window.FazendaRP.Pages.operacional.calendario = {
    container: null,
    currentMonth: new Date().getMonth(),
    currentYear: new Date().getFullYear(),
    prescricoes: [],
    atividades: [],

    render: async function (container) {
        this.container = container;

        // Load data
        await this.loadData();

        const html = `
            <div style="background: white; border-radius: 12px; padding: 25px; box-shadow: 0 2px 8px rgba(0,0,0,0.06);">
                <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
                    <h3 style="margin:0; color:#1f2937;">
                        <i class="fas fa-calendar-days" style="color:#059669;"></i> Calendário Operacional
                    </h3>
                    <button onclick="window.FazendaRP.Pages.operacional.calendario.hoje()" style="background:#059669; color:white; border:none; padding:8px 16px; border-radius:6px; font-weight:600; cursor:pointer;">
                        <i class="fas fa-calendar-day"></i> Hoje
                    </button>
                </div>

                <!-- Navegação Mês/Ano -->
                <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px; padding:15px; background:#f9fafb; border-radius:8px;">
                    <button onclick="window.FazendaRP.Pages.operacional.calendario.mesAnterior()" style="background:white; border:1px solid #d1d5db; padding:8px 16px; border-radius:6px; cursor:pointer;">
                        <i class="fas fa-chevron-left"></i> Anterior
                    </button>
                    <h4 id="month-year-display" style="margin:0; color:#1f2937; font-size:1.2rem;">
                        ${this.getMonthName(this.currentMonth)} ${this.currentYear}
                    </h4>
                    <button onclick="window.FazendaRP.Pages.operacional.calendario.proximoMes()" style="background:white; border:1px solid #d1d5db; padding:8px 16px; border-radius:6px; cursor:pointer;">
                        Próximo <i class="fas fa-chevron-right"></i>
                    </button>
                </div>

                <!-- Legenda -->
                <div style="display:flex; gap:20px; margin-bottom:15px; padding:12px; background:#eff6ff; border-radius:6px; flex-wrap:wrap;">
                    <div style="display:flex; align-items:center; gap:5px;">
                        <div style="width:12px; height:12px; background:#3b82f6; border-radius:50%;"></div>
                        <span style="font-size:0.85rem; color:#1e40af;">Prescrições</span>
                    </div>
                    <div style="display:flex; align-items:center; gap:5px;">
                        <div style="width:12px; height:12px; background:#059669; border-radius:50%;"></div>
                        <span style="font-size:0.85rem; color:#065f46;">Atividades</span>
                    </div>
                    <div style="display:flex; align-items:center; gap:5px;">
                        <div style="width:12px; height:12px; background:#9333ea; border-radius:50%;"></div>
                        <span style="font-size:0.85rem; color:#6b21a8;">Ambos</span>
                    </div>
                </div>

                <!-- Calendário -->
                <div id="calendar-grid"></div>

                <!-- Modal para detalhes do dia -->
                <div id="modal-dia" style="display:none; position:fixed; top:0; left:0; right:0; bottom:0; background:rgba(0,0,0,0.5); z-index:9999; overflow-y:auto;">
                    <div style="min-height:100vh; display:flex; align-items:center; justify-content:center; padding:20px;">
                        <div style="background:white; border-radius:12px; max-width:700px; width:100%; max-height:90vh; overflow-y:auto;">
                            <div id="modal-dia-content"></div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        container.innerHTML = html;
        this.renderCalendar();
    },

    loadData: async function () {
        try {
            // Buscar prescrições do mês
            const startDate = new Date(this.currentYear, this.currentMonth, 1).toISOString().split('T')[0];
            const endDate = new Date(this.currentYear, this.currentMonth + 1, 0).toISOString().split('T')[0];

            const { data: presc } = await window.FazendaRP.supabase
                .from('operacional_prescricoes')
                .select('*')
                .gte('data_inicio', startDate)
                .lte('data_fim', endDate);

            const { data: ativ } = await window.FazendaRP.supabase
                .from('operacional_atividades')
                .select('*')
                .gte('data_atividade', startDate)
                .lte('data_atividade', endDate);

            this.prescricoes = presc || [];
            this.atividades = ativ || [];

        } catch (err) {
            console.error('Erro ao carregar dados do calendário:', err);
        }
    },

    renderCalendar: function () {
        const grid = document.getElementById('calendar-grid');
        if (!grid) return;

        const firstDay = new Date(this.currentYear, this.currentMonth, 1).getDay();
        const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
        const today = new Date();

        let html = `
            <div style="display:grid; grid-template-columns:repeat(7, 1fr); gap:8px;">
                <!-- Cabeçalho dias da semana -->
                ${['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'].map(day => `
                    <div style="text-align:center; font-weight:700; color:#6b7280; padding:10px 0; font-size:0.85rem;">
                        ${day}
                    </div>
                `).join('')}
        `;

        // Espaços vazios antes do primeiro dia
        for (let i = 0; i < firstDay; i++) {
            html += '<div style="background:#f9fafb; border-radius:8px; min-height:100px;"></div>';
        }

        // Dias do mês
        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(this.currentYear, this.currentMonth, day);
            const dateStr = date.toISOString().split('T')[0];
            const isToday = date.toDateString() === today.toDateString();

            const prescNoDia = this.getPrescricoesNoDia(dateStr);
            const ativNoDia = this.getAtividadesNoDia(dateStr);

            const hasPresc = prescNoDia.length > 0;
            const hasAtiv = ativNoDia.length > 0;

            let borderColor = '#e5e7eb';
            let bgColor = 'white';
            if (hasPresc && hasAtiv) {
                borderColor = '#9333ea';
                bgColor = '#faf5ff';
            } else if (hasPresc) {
                borderColor = '#3b82f6';
                bgColor = '#eff6ff';
            } else if (hasAtiv) {
                borderColor = '#059669';
                bgColor = '#f0fdf4';
            }

            if (isToday) {
                borderColor = '#f59e0b';
                bgColor = '#fffbeb';
            }

            html += `
                <div onclick="window.FazendaRP.Pages.operacional.calendario.abrirDia('${dateStr}')" 
                     style="background:${bgColor}; border:2px solid ${borderColor}; border-radius:8px; padding:10px; min-height:100px; cursor:pointer; transition:all 0.2s; position:relative;"
                     onmouseover="this.style.transform='scale(1.02)'; this.style.boxShadow='0 4px 12px rgba(0,0,0,0.1)';"
                     onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='none';">
                    
                    <div style="font-weight:${isToday ? '700' : '600'}; color:#1f2937; font-size:1rem; margin-bottom:5px;">
                        ${day}
                    </div>

                    ${hasPresc ? `
                        <div style="background:#3b82f6; color:white; font-size:0.7rem; padding:2px 6px; border-radius:10px; margin-bottom:3px; text-align:center;">
                            ${prescNoDia.length} Prescr.
                        </div>
                    ` : ''}

                    ${hasAtiv ? `
                        <div style="background:#059669; color:white; font-size:0.7rem; padding:2px 6px; border-radius:10px; text-align:center;">
                            ${ativNoDia.length} Ativ.
                        </div>
                    ` : ''}

                    ${isToday ? `
                        <div style="position:absolute; top:5px; right:5px; background:#f59e0b; color:white; width:20px; height:20px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:0.7rem; font-weight:700;">
                            •
                        </div>
                    ` : ''}
                </div>
            `;
        }

        html += '</div>';
        grid.innerHTML = html;
    },

    getPrescricoesNoDia: function (dateStr) {
        return this.prescricoes.filter(p => {
            const inicio = p.data_inicio;
            const fim = p.data_fim;
            return dateStr >= inicio && dateStr <= fim;
        });
    },

    getAtividadesNoDia: function (dateStr) {
        return this.atividades.filter(a => {
            return a.data_atividade === dateStr ||
                (a.data_fim && dateStr >= a.data_atividade && dateStr <= a.data_fim);
        });
    },

    abrirDia: function (dateStr) {
        const modal = document.getElementById('modal-dia');
        const content = document.getElementById('modal-dia-content');

        if (!modal || !content) return;

        const date = new Date(dateStr + 'T12:00:00');
        const prescNoDia = this.getPrescricoesNoDia(dateStr);
        const ativNoDia = this.getAtividadesNoDia(dateStr);

        const shared = window.FazendaRP.Pages.operacional.shared;

        let html = `
            <div style="padding:30px;">
                <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px; padding-bottom:15px; border-bottom:2px solid #e5e7eb;">
                    <h3 style="margin:0; color:#1f2937;">
                        <i class="fas fa-calendar-day"></i> ${date.toLocaleDateString('pt-BR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                    </h3>
                    <button onclick="document.getElementById('modal-dia').style.display='none'" style="background:none; border:none; font-size:1.5rem; color:#6b7280; cursor:pointer;">
                        <i class="fas fa-times"></i>
                    </button>
                </div>

                <!-- Prescrições -->
                ${prescNoDia.length > 0 ? `
                    <div style="margin-bottom:25px;">
                        <h4 style="color:#1e40af; margin-bottom:15px;">
                            <i class="fas fa-clipboard-check"></i> Prescrições (${prescNoDia.length})
                        </h4>
                        ${prescNoDia.map(p => `
                            <div style="background:#eff6ff; border-left:4px solid #3b82f6; padding:15px; border-radius:8px; margin-bottom:10px;">
                                <div style="font-weight:700; color:#1e40af; margin-bottom:5px;">${p.titulo}</div>
                                <div style="color:#6b7280; font-size:0.85rem; margin-bottom:5px;">
                                    <i class="fas fa-seedling"></i> ${p.tipo_operacao}
                                    ${p.estadio_fenologico ? ` • ${p.estadio_fenologico}` : ''}
                                </div>
                                <div style="color:#6b7280; font-size:0.85rem;">
                                    <i class="fas fa-calendar"></i> Janela: ${shared.formatDateRange(p.data_inicio, p.data_fim)}
                                </div>
                                ${p.custo_estimado ? `
                                    <div style="color:#059669; font-weight:600; margin-top:5px;">
                                        💰 Custo estimado: ${shared.formatCurrency(p.custo_estimado)}
                                    </div>
                                ` : ''}
                                <div style="margin-top:10px;">
                                    <button onclick="window.FazendaRP.Pages.operacional.prescricoes.executarPrescricao('${p.id}'); document.getElementById('modal-dia').style.display='none';" 
                                            style="background:#059669; color:white; border:none; padding:6px 12px; border-radius:6px; font-weight:600; cursor:pointer; font-size:0.85rem;">
                                        <i class="fas fa-play"></i> Executar
                                    </button>
                                </div>
                            </div>
                        `).join('')}
                    </div>
                ` : ''}

                <!-- Atividades -->
                ${ativNoDia.length > 0 ? `
                    <div>
                        <h4 style="color:#065f46; margin-bottom:15px;">
                            <i class="fas fa-pen-to-square"></i> Atividades Realizadas (${ativNoDia.length})
                        </h4>
                        ${ativNoDia.map(a => `
                            <div style="background:#f0fdf4; border-left:4px solid #059669; padding:15px; border-radius:8px; margin-bottom:10px;">
                                <div style="font-weight:700; color:#065f46; margin-bottom:5px;">${a.tipo_operacao}</div>
                                <div style="color:#6b7280; font-size:0.85rem; margin-bottom:5px;">
                                    ${a.estadio_fenologico ? `<i class="fas fa-leaf"></i> ${a.estadio_fenologico} • ` : ''}
                                    ${a.operador ? `<i class="fas fa-user"></i> ${a.operador}` : ''}
                                </div>
                                ${a.custo_total ? `
                                    <div style="color:#059669; font-weight:600; margin-top:5px;">
                                        💰 Custo real: ${shared.formatCurrency(a.custo_total)}
                                    </div>
                                ` : ''}
                                ${a.observacoes ? `
                                    <div style="color:#6b7280; font-size:0.85rem; margin-top:8px; font-style:italic;">
                                        "${a.observacoes}"
                                    </div>
                                ` : ''}
                            </div>
                        `).join('')}
                    </div>
                ` : ''}

                ${prescNoDia.length === 0 && ativNoDia.length === 0 ? `
                    <div style="text-align:center; padding:40px; color:#9ca3af;">
                        <i class="fas fa-calendar-xmark" style="font-size:3rem; margin-bottom:15px;"></i>
                        <p style="margin:0;">Nenhuma prescrição ou atividade neste dia</p>
                    </div>
                ` : ''}
            </div>
        `;

        content.innerHTML = html;
        modal.style.display = 'block';

        // Click outside to close
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                modal.style.display = 'none';
            }
        });
    },

    mesAnterior: function () {
        this.currentMonth--;
        if (this.currentMonth < 0) {
            this.currentMonth = 11;
            this.currentYear--;
        }
        this.render(this.container);
    },

    proximoMes: function () {
        this.currentMonth++;
        if (this.currentMonth > 11) {
            this.currentMonth = 0;
            this.currentYear++;
        }
        this.render(this.container);
    },

    hoje: function () {
        const today = new Date();
        this.currentMonth = today.getMonth();
        this.currentYear = today.getFullYear();
        this.render(this.container);
    },

    getMonthName: function (month) {
        const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
            'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
        return months[month];
    }
};
